export enum CartType {
    Client,
    Server
}
